import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum PaymentSchedule {
  PREPAID = "prepay",
  POSTPAID = "postpay",
}

export enum AlertStatus {
  ALERTED = "alerted",
  UNALERTED = "unalerted",
}

export const BaseBalanceSchema = z.object({
  amount: z.string(),
  paymentSchedule: createEnum(PaymentSchedule, { enumName: "PaymentSchedule" }),
  alertThreshold: z.string(),
  alertStatus: createEnum(AlertStatus, { enumName: "AlertStatus" }),
});

// Map settings types to a Mongoose model and a Typescript interface
export const balanceSchemas = { "outbound-labels": BaseBalanceSchema };

export enum BalanceTypes {
  OUTBOUND_LABELS = "outbound-labels",
}

const BalanceSchemaBaseDocument = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  kind: createEnum(BalanceTypes, { enumName: "BalanceTypes" }),
});

const OutboundLabelsBalanceDocument = BalanceSchemaBaseDocument.extend({
  kind: z.literal(BalanceTypes.OUTBOUND_LABELS),
  balance: balanceSchemas["outbound-labels"],
});

export const BalanceSchemaDocument = z.discriminatedUnion("kind", [
  OutboundLabelsBalanceDocument,
]);

export type balanceTypes = {
  [key in keyof typeof balanceSchemas]: z.infer<(typeof balanceSchemas)[key]>;
};
